import PropTypes from 'prop-types'
import { format, isDate, parse } from 'date-fns'
import React, { memo, useMemo } from 'react'
import es from 'date-fns/locale/es'
import { registerLocale } from 'react-datepicker'
import { Text } from '@chakra-ui/react'
registerLocale('es', es)

const DateCell = ({ value, textVariant = '' }) => {
  const formatValue = useMemo(() => {
    if (value?.includes('T')) return value.replace('T', ' ')
    return value
  }, [value])

  const rechargeDate = useMemo(() => {
    if (formatValue) {
      if (
        isDate(
          parse(isDate(formatValue.split(' ')[0]), 'dd-MM-yyyy', new Date(), {
            locale: es,
          }),
        )
      ) {
        const newDate = formatValue.split(' ')[0]
        const isYearFirst = !newDate.substring(0, 3).includes('-')
        if (isYearFirst) {
          return format(
            parse(formatValue.split(' ')[0], 'yyyy-MM-dd', new Date(), {
              locale: es,
            }),
            'MMM dd, yyyy',
            { locale: es },
          )
        }
        return format(
          parse(formatValue.split(' ')[0], 'dd-MM-yyyy', new Date(), {
            locale: es,
          }),
          'MMM dd, yyyy',
          { locale: es },
        )
      }

      const date = parse(formatValue, 'dd-MM-yyyy', new Date(), { locale: es })
      return format(date, 'MMM dd, yyyy', { locale: es })
    }
    return ''
  }, [formatValue])

  return (
    <Text
      variant={textVariant || 'body2'}
      textAlign="start"
      textTransform="capitalize"
    >
      {rechargeDate}
    </Text>
  )
}

DateCell.propTypes = {
  textVariant: PropTypes.string,
  value: PropTypes.string,
}

export default memo(DateCell)
